<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Users</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="showNewUser"
      mat-button
      color="lightGreen"
      (click)="createNewUser()"
    >
      Create New User
    </button>
  </div>
</div>

<div class="users-list">
  <div class="container users-container">
    <div class="container-header no-bottom-border">
      <div class="text">User List</div>
      <div class="options">
        <button
          *ngIf="showNewUser"
          mat-icon-button
          [matMenuTriggerFor]="usersMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant vertical-menu" #usersMenu="matMenu">
          <button
            *ngIf="showNewUser"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewUser()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New User</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      class="container-content"
      lhpeElementLoader
      #userElementLoader="elementloader"
    >
      <table #usersTable mat-table [dataSource]="userDataSource" matSort>
        <ng-container matColumnDef="last_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
          <td mat-cell *matCellDef="let row">{{ row.last_name }}</td>
        </ng-container>

        <ng-container matColumnDef="first_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
          <td mat-cell *matCellDef="let row">{{ row.first_name }}</td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
          <td mat-cell *matCellDef="let row">{{ row.company }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let row">{{ row.email }}</td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button
              *ngIf="showEdit"
              mat-button
              (click)="edit(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showEdit" class="empty-btn-space"></div>
            <button
              *ngIf="row.id !== currentUser.id && showDelete"
              class="icon-btn"
              mat-button
              (click)="delete(row)"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div
              *ngIf="!(row.id !== currentUser.id && showDelete)"
              class="empty-btn-space"
            ></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage"
      (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
